import featureToggleEnv from "../featureToggle.json";
import { env } from "./environment";


export const featureToggle = featureToggleEnv[env()] || {};